
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/komodo-wallet/mobile/komodo-wallet-faq",
      function () {
        return require("private-next-pages/en/docs/komodo-wallet/mobile/komodo-wallet-faq/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/komodo-wallet/mobile/komodo-wallet-faq"])
      });
    }
  